export const getDeviceType = (): string => {
  const userAgent = window.navigator.userAgent.toLowerCase();

  const getMobileType = (): string => {
    if (userAgent.includes('iphone')) return 'iPhone';
    if (userAgent.includes('ipad')) return 'iPad';
    if (userAgent.includes('android')) return 'Android';
    return 'Unknown';
  };

  const getDesktopType = (): string => {
    if (userAgent.includes('mac')) return 'macOS';
    if (userAgent.includes('win')) return 'Windows';
    if (userAgent.includes('linux')) return 'Linux';
    return 'Desktop';
  };

  if (userAgent.includes('mobile')) return getMobileType();
  if (userAgent.includes('tablet')) return getMobileType();
  return getDesktopType();
};
